import { useMutation } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
const updateRanges = async () => ArchiveArchiveIndexSet.rebuildIndexRanges();
const useArchiveIndexSetRangesMutation = () => {
  const rebuild = useMutation({
    mutationFn: updateRanges,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.index_ranges_failed", { ns: "enterprise_archive", error: errorThrown }),
        i18n.t("notifications.index_ranges_failed_title", { ns: "enterprise_archive" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.index_ranges_success", { ns: "enterprise_archive" }),
        i18n.t("notifications.success_title", { ns: "enterprise_archive" })
      );
    }
  });
  return {
    rebuildArchiveIndexSetRangesMutation: rebuild.mutateAsync
  };
};
export default useArchiveIndexSetRangesMutation;
